import { render, staticRenderFns } from "./Mandate.vue?vue&type=template&id=0394bf48&"
import script from "./Mandate.vue?vue&type=script&lang=ts&"
export * from "./Mandate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports